import { render, staticRenderFns } from "./Promo2020_Ptgo.vue?vue&type=template&id=0d421bec&scoped=true&"
import script from "./Promo2020_Ptgo.vue?vue&type=script&lang=js&"
export * from "./Promo2020_Ptgo.vue?vue&type=script&lang=js&"
import style0 from "./Promo2020_Ptgo.vue?vue&type=style&index=0&id=0d421bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d421bec",
  null
  
)

export default component.exports